// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SourcesProgressBar from './SourcesProgressBar';
import formattingUtils from '../../utils/formattingUtils';
import classNames from 'classnames';


class SourcesStackItemHeader extends Component {

  renderProgressBar() {
    const {
      canViewTotalIndexed,
      dataIndexed,
      dataRequired,
      percentIndexed,
      totalDataRequired,
      ciscoDataPerDay,
      nonCiscoDataPerDay,
      ciscoDataIndexed,
      nonCiscoDataIndexed
    } = this.props;

    const containerClassNames = classNames({
      'col-md-5': canViewTotalIndexed,
      'col-md-12': !canViewTotalIndexed,
      'sources-stack-item__progress-bar-container': true,
      'progress-bar-container': true
    });

    return (
      <div className='row header-row'>
        <div className={containerClassNames}>
          <SourcesProgressBar
            dataIndexed={dataIndexed}
            dataRequired={dataRequired}
            progressBarHeight={20}
            percentIndexed={percentIndexed}
            isPercentage={canViewTotalIndexed}
            totalDataRequired={totalDataRequired}
            ciscoDataPerDay={ciscoDataPerDay}
            nonCiscoDataPerDay={nonCiscoDataPerDay}
            ciscoDataIndexed={ciscoDataIndexed}
            nonCiscoDataIndexed={nonCiscoDataIndexed}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      title,
      configuredItemsCount,
      itemsCompleteCount,
      totalItemsCount
    } = this.props;

    return (
      <div className='sources-stack-item-header'>
        <div className='row header-row'>
          <div className='col-xs-9'>
            <label className='h5 accordion-title'>
              {title}
              <span className='configured-items sub-text'>
                {formattingUtils.numberWithCommas(configuredItemsCount)} Configured items
              </span>
            </label>
          </div>
          <div className='col-xs-2'>
            {itemsCompleteCount === totalItemsCount && <i className='icon icon-check-green' /> }
            {`${itemsCompleteCount}/${totalItemsCount} Items Complete`}
          </div>
          <div className='col-xs-1 text-center'>
            <div className='accordion-arrow' />
          </div>
        </div>
        {this.renderProgressBar()}
      </div>
    );
  }
}

SourcesStackItemHeader.propTypes = {
  title: PropTypes.string.isRequired,
  configuredItemsCount: PropTypes.number.isRequired,
  itemsCompleteCount: PropTypes.number.isRequired,
  totalItemsCount: PropTypes.number.isRequired,
  dataIndexed: PropTypes.number.isRequired,
  totalDataRequired: PropTypes.number.isRequired,
  dataRequired: PropTypes.number.isRequired,
  percentIndexed: PropTypes.number.isRequired,
  canViewTotalIndexed: PropTypes.bool.isRequired,
  ciscoDataPerDay: PropTypes.number,
  nonCiscoDataPerDay: PropTypes.number,
  ciscoDataIndexed: PropTypes.number,
  nonCiscoDataIndexed: PropTypes.number
};

export default SourcesStackItemHeader;



// WEBPACK FOOTER //
// ./src/components/sources/SourcesStackItemHeader.js